import React, { useEffect, useState } from "react";
import { Modal, Box, TextField, Button, Typography, useMediaQuery, useTheme } from "@mui/material";

const SubmitPracticeModal = ({ open, handleClose, handleSubmit,selectedPractice }) => {
  const [assignmentLink, setAssignmentLink] = useState("");
   const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

useEffect(() => {
    if (selectedPractice) {
      setAssignmentLink(selectedPractice?.learnerDailyPractice?.submission_link || "");
    }
},[selectedPractice])

  const onSubmit = () => {
    handleSubmit(assignmentLink);
    setAssignmentLink(""); 
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minWidth: isMobile ? "70%" : "40%",
          maxWidth: isMobile ? "100%" : "400px",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography sx={{width:"100%", textAlign:"start",mb:3}} variant="h5" gutterBottom>
          Submit Practice 
        </Typography>
        <TextField
          fullWidth
          label="Practice Link"
          variant="outlined"
          value={assignmentLink}
          onChange={(e) => setAssignmentLink(e.target.value)}
          sx={{ mb: 3 }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={!assignmentLink.trim()}
        >
          Submit
        </Button>
      </Box>
    </Modal>
  );
};

export default SubmitPracticeModal;
